import { sendRequest } from '@infrastructure/api/api';
import { ApiMessageResponse } from '@core/types/apiMessageResponse';
import { UpdateUserProfileRequest, UserProfile } from '../types/profile';

/**
 * Fetches the current user's profile
 * @returns Promise<UserProfile>
 */
export const fetchUserProfile = async (): Promise<UserProfile> => {
  const response = await sendRequest<any, UserProfile>('GET', '/user/profile');

  if (response.isSuccess()) {
    return response.getData()!;
  } else {
    throw new Error(response.getError()?.detail || 'Failed to fetch user profile');
  }
};

/**
 * Updates the current user's profile
 * @param data Partial profile fields to update
 * @returns Promise<ApiMessageResponse>
 */
export const updateUserProfile = async (data: UpdateUserProfileRequest): Promise<ApiMessageResponse> => {
  const response = await sendRequest<UpdateUserProfileRequest, ApiMessageResponse>('POST', '/user/profile/update', data);

  if (response.isSuccess()) {
    return response.getData()!;
  } else {
    throw new Error(response.getError()?.detail || 'Failed to update profile');
  }
};
